import { ItemAccount } from './itemaccount.model';

export class AccountResult {
  Pieces: ItemAccount[];
  TotalPages: number;
  TotalEntries: number;
  CurrentPage: number;
  Solde: number;

  static extractData(response: AccountResult): AccountResult {
    const result = new AccountResult();
    Object.assign(result, response);
    result.Pieces = new Array<ItemAccount>();
    response.Pieces.forEach(piece => {
      const pieceEnrichie = new ItemAccount();
      Object.assign(pieceEnrichie, piece);
      pieceEnrichie.DateEmission = new Date(piece.DateEmission);
      pieceEnrichie.DateEcheance = new Date(piece.DateEcheance);
      result.Pieces.push(pieceEnrichie);
    });
    return result;
  }
}
